import { Subject } from 'rxjs';

import { filter, map } from 'rxjs/operators';

class EntriesEventBus {
  static EVENTS = {
    resultsRequested: 'Entries.resultsRequested',
    resultsChunkLoaded: 'Entries.resultsChunkLoaded',
  };

  static _validateEvent(eventName) {
    if (!Object.values(this.EVENTS).includes(eventName)) {
      Logger.warn('EntriesEventBus - unsupported event: ', eventName);
      return false;
    }
    return true;
  }

  _subject;

  constructor() {
    this._subject = new Subject();
  }

  get EVENTS() {
    return this.constructor.EVENTS;
  }

  emit(eventName, data) {
    if (!this.constructor._validateEvent(eventName)) return;

    this._subject.next({ eventName, data });
  }

  // Should return unsubscribe fn
  on(eventName, handler) {
    if (!this.constructor._validateEvent(eventName)) return () => {};

    const subscription = this._subject
      .pipe(
        filter(({ eventName: subjectEventName }) => subjectEventName === eventName),
        map(({ data: subjectData }) => subjectData)
      )
      .subscribe({ next: handler });

    return () => subscription.unsubscribe();
  }
}

export default new EntriesEventBus();
